import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'bau365-section-load-more',
  templateUrl: './section-load-more.component.html',
  styleUrls: ['./section-load-more.component.scss'],
})
export class SectionLoadMoreComponent {
  @Output() loadMore: EventEmitter<boolean> = new EventEmitter();
  @Input() count: number | null = null;
  @Input() loaded: boolean | null = null;

  onLoadMore() {
    this.loadMore.emit(true);
  }
}
